import { CookieConsentData, Participant, UserOnlineStatus, UserPlan } from "@/types";

// Use string paths for static assets
// Files in /public are served at root, so /assets/fileTypes/... works
// All file types now use a single generic file icon
const FILE_ICON = "/assets/fileTypes/file-icon.svg";

export const OAUTH_GOOGLE_ENDPOINT = "https://accounts.google.com/o/oauth2/v2/auth";
export const OAUTH_APPLE_ENDPOINT = "https://appleid.apple.com/auth/authorize";

export const GOOGLE_APP_STORE_LINK =
	"https://play.google.com/store/apps/details?id=com.techxeed&pcampaignid=web_share";
export const APPLE_APP_STORE_LINK = "https://apps.apple.com/us/app/techxeed/id6758790348";

export const LOCAL_INBOX_PAGE_KEY = "local-inbox-page";
export const LOCAL_ADMIN_INBOX_PAGE_KEY = "local-admin-inbox-page";
export const LOCAL_GDPR_CONSENT = "local-gdpr-consent";
export const LOCAL_AFFILIATE_REF_KEY = "local-affiliate-ref";
export const LOCAL_CHAT_NOTICE_KEY = "local-chat-notice";

export const SEE_HOW_IT_WORKS =
	"https://techxeed-prod-data.s3.us-east-1.amazonaws.com/local_vids/See_How_Techxeed_Works.mp4";

export const Currency = "$";
export const Discount = 10;

export const progressList = [
	{ value: "NEW", lable: "New" },
	{ value: "IN_PROGRESS", lable: "In Progress" },
	{ value: "COMPLETED", lable: "Completed" },
	{ value: "IN_REVIEW", lable: "In Review" },
	{ value: "LATE", lable: "Late" },
	{ value: "CANCELLED", lable: "Cancelled" },
];

export const roles = [
	{ value: "ADMIN", lable: "Admin" },
	{ value: "CUSTOMER", lable: "Customer" },
	{ value: "DIRECTOR", lable: "Director" },
];

export const supportedTypes = [
	"image/jpeg",
	"image/png",
	"image/gif",
	"image/svg+xml", // Added for SVG images
	"image/webp", // Added for WebP images
	"image/bmp", // Added for BMP images
	"image/tiff", // Added for TIFF images
	"image/vnd.microsoft.icon", // Added for ICO files
	// Video MIME Types
	"video/mp4",
	"video/webm",
	"video/ogg",
	"video/mpeg", // Added for MPEG videos
	"video/3gpp", // Added for 3GPP videos, used on mobile devices
	"video/3gpp2", // Added for 3GPP2 videos
	"video/x-msvideo", // Added for AVI videos
	"video/x-ms-wmv", // Added for Windows Media Video (WMV) files
	"video/quicktime", // Added for QuickTime (MOV) videos
];

export const getImageType = (type: string) => {
	// All file types now use a single generic file icon
	return FILE_ICON;
};

export const DELETED_PARTICIPANT: Participant = {
	_id: "0x1",
	firstName: "Deleted",
	lastName: "User",
	onlineStatus: UserOnlineStatus.OFFLINE,
	email: "deleted@techxeed.com",
	plan: { duration: UserPlan.free, planID: "" },
	role: "CUSTOMER",
	bio: "",
	deletedAccount: true,
};

export const DEFAULT_COOKIE_CONSENT: CookieConsentData = {
	required: true,
	performance: true,
	advertisements: true,
};
